import { render } from "./Table.vue?vue&type=template&id=54d27faa"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=54d27faa&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "54d27faa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54d27faa', script)) {
    api.reload('54d27faa', script)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=54d27faa", () => {
    api.rerender('54d27faa', render)
  })

}

script.__file = "src/components/no-message/Table.vue"

export default script